import { RowData } from '../types.ts';

export const toPixel = (
  value: number,
  plotWidth: number,
  minValue: number,
  maxValue: number,
): number => ((value - minValue) / (maxValue - minValue)) * plotWidth;

export const formatValue = (v: number) => `$${v.toLocaleString('en-US')}`;

const TICK_STEPS = [5000, 10000, 20000, 50000, 100000];
const MAX_TICKS = 8;

export const computeChartDomain = (
  chartData: RowData[],
): { minValue: number; maxValue: number; ticks: number[] } => {
  const allValues = chartData.flatMap((row) =>
    [row.value, row.min, row.max, row.average, row.median].filter(
      (v): v is number => v !== undefined,
    ),
  );

  const rawMin = allValues.length > 0 ? Math.min(...allValues) : 0;
  const rawMax = allValues.length > 0 ? Math.max(...allValues) : 100000;

  // Pick the smallest step that keeps tick count <= MAX_TICKS
  const tickStep: number =
    TICK_STEPS.find((step) => {
      const min = Math.floor(rawMin / step) * step - step;
      const max = Math.ceil(rawMax / step) * step + step;
      return Math.round((max - min) / step) + 1 <= MAX_TICKS;
    }) ?? TICK_STEPS[TICK_STEPS.length - 1]!;

  // Snap outward to nearest tickStep and add one extra step of padding on each side
  const minValue = Math.floor(rawMin / tickStep) * tickStep - tickStep;
  const maxValue = Math.ceil(rawMax / tickStep) * tickStep + tickStep;

  const ticks: number[] = [];
  for (let t = minValue; t <= maxValue; t += tickStep) ticks.push(t);

  return { minValue, maxValue, ticks };
};
